import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-regions-dropdown',
  templateUrl: './regions-dropdown.component.html',
  styleUrls: ['./regions-dropdown.component.scss']
})
export class RegionsDropdownComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() regions: string[];

  constructor() {}

  ngOnInit() {}
}
